<template>
<article class="info-section">
  <div class="info-section-header">
    <info-section-heading>{{formatUser(currentUser.username)}} Account</info-section-heading>
    <!-- <pre>{{currentUser}}</pre> -->
    <!-- <pre>{{herd}}</pre> -->
    <!-- <pre>{{wishlist}}</pre> -->
    <!-- <pre>{{favorites}}</pre> -->
  </div>
  <div class="user-dashboard">
    <div class="form-section">
      <div class="details-block">
        <h2 class="dashboard-section-heading">Update Account Details</h2>
        <FormUserEdit
          v-if="currentUser"
          @updatedUser="update"
          :user="currentUser"
        />
      </div>
      <div class="list-stats details-block">
        <h2 class="dashboard-section-heading">List Information</h2>
        <p>Wishlist Progress</p>
        <p>Completed Groups</p>
        <p>Ponies Sold</p>
      </div>
      <!-- <div class="activity-feed-section details-block" v-if="activity && activity.length">
        <h2 class="dashboard-section-heading">Activity Feed</h2>
        <ActivityFeed :activity="activity" />
      </div> -->
    </div>
    <div class="user-info">
      <div class="details-block">
        <h2 class="dashboard-section-heading">Member Details</h2>
        <ul class="details-list">
          <li><span class="elr-bold">Name:</span> {{currentUser.full_name}}</li>
          <li><span class="elr-bold">Country:</span> {{currentUser.country}}</li>
          <li><span class="elr-bold">Role:</span> {{currentUser.role_name}}</li>
        </ul>
        <div class="button-holder">
          <button class="elr-button elr-button-danger" @click="remove">Delete Account</button>
        </div>
      </div>
      <div class="details-block">
        <h2 class="dashboard-section-heading">Herd Details</h2>
        <ul class="details-list" v-if="herd">
          <li><span class="elr-bold">Collection Status:</span> {{herd.visibility}}</li>
          <li><span class="elr-bold">Count:</span> {{herd.item_count}} {{plural('pony', herd.item_count)}}</li>
        </ul>
        <div class="button-holder">
          <router-link class="elr-button elr-button-primary" :to="`/herd/${currentUser.id}`">View Herd</router-link> 
          <router-link class="elr-button elr-button-primary" :to="`/herd/${currentUser.id}/edit`">Edit Herd Details</router-link>
        </div>
      </div>
      <div class="details-block">
        <h2 class="dashboard-section-heading">Wishlist Details</h2>
        <ul class="details-list" v-if="wishlist">
          <li><span class="elr-bold">Wishlist Status:</span> {{wishlist.visibility}}</li>
          <li><span class="elr-bold">Count:</span> {{wishlist.item_count}} {{plural('pony', wishlist.item_count)}}</li>
        </ul>
        <div class="button-holder"><router-link class="elr-button elr-button-primary" :to="`/wishlist/${currentUser.username}`">View Wishlist</router-link></div>
      </div>
      <div class="details-block">
        <h2 class="dashboard-section-heading">Favorites Details</h2>
        <ul class="details-list" v-if="favorites">
          <li><span class="elr-bold">Favorites Status:</span> {{favorites.visibility}}</li>
          <li><span class="elr-bold">Count:</span> {{favorites.item_count}} {{plural('pony', favorites.item_count)}}</li>
        </ul>
        <div class="button-holder"><router-link class="elr-button elr-button-primary" :to="`/favorite/${currentUser.username}`">View Favorites</router-link></div>
      </div>
    </div>
  </div>
</article>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { capitalize, formatUser, showPrompt, plural } from '../../utils/helpers';
import FormUserEdit from '../../components/FormUserEdit/FormUserEdit';
import InfoSectionHeading from '../../components/InfoSectionHeading/InfoSectionHeading';
// import ActivityFeed from '../../components/ActivityFeed/ActivityFeed';

export default {
  name: 'Dashboard',
  data() {
    return {
      num: 12,
      herd: {},
      wishlist: {},
      favorites: {},
      activity: [],
    }
  },
  components: {
    // ActivityFeed,
    FormUserEdit,
    InfoSectionHeading
  },
  async mounted() {
    if (this.currentUser && this.currentUser.username) {
      this.herd = await this.fetchHerd({ id: this.currentUser.username, num: this.num });
      this.wishlist = await this.fetchWishlist({ id: this.currentUser.username, num: this.num });
      this.favorites = await this.fetchFavorites({
        id: this.currentUser.username,
        num: this.num
      });
      // this.fetchActivity(this.currentUser.id);
      // this.fetchFavorites(this.currentUser.username);
    }
  },
  watch: {
    async currentUser() {
      // this.fetchActivity(this.currentUser.id);
      this.herd = await this.fetchHerd({ id: this.currentUser.username, num: this.num });
      this.wishlist = await this.fetchWishlist({ id: this.currentUser.username, num: this.num });
      this.favorites = await this.fetchFavorites({
        id: this.currentUser.username,
        num: this.num
      });
      // this.fetchFavorites(this.currentUser.username);
    }
  },
  computed: {
    ...mapState('currentUser', ['currentUser', 'authenticated']),
    // ...mapState('activity', ['items']),
  },
  methods: {
    ...mapActions('activity', { fetchActivity: 'FETCH_ALL_USER' }),
    ...mapActions('herd', { fetchHerd: 'FETCH' }),
    ...mapActions('wishlist', { fetchWishlist: 'FETCH' }),
    ...mapActions('favoriteList', { fetchFavorites: 'FETCH' }),
    plural,
    capitalize,
    formatUser,
    update() {},
    remove() {
      showPrompt();
    },
    // fetchActivity(id) {
    //   this.$store.dispatch('activity/FETCH_ALL_USER', {
    //     id,
    //     num: this.num
    //   });
    // },
    // fetchHerd(id) {
    //   this.$store.dispatch('herd/FETCH', {
    //     id,
    //     num: this.num
    //   });
    // },
    // fetchWishlist(id) {
    //   this.$store.dispatch('wishlist/FETCH', {
    //     id,
    //     num: this.num
    //   });
    // },
    // fetchFavorites(id) {
    //   this.$store.dispatch('favoriteList/FETCH', {
    //     id,
    //     num: this.num
    //   });
    // }
  }
};
</script>

<style scoped lang="scss">
@import '../../assets/sass/_config.scss';

.user-dashboard {
  margin: 20px auto;
  max-width: $max-width;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}

.form-section {
  flex: 1;
}

.button-holder {
  text-align: left;

  .elr-button {
    margin-right: 10px;
  }
}

.user-info {
  flex: 1;
  padding-left: 40px;
}

.details-block {
  margin-bottom: 40px;
  padding: 30px 40px;
  border-radius: 5px;
  background-color: $aquamarine;
  box-shadow: $shadow;
}

.button-holder ~ .details-list {
  margin-bottom: 20px;
}

.dashboard-section-heading {
  font-size: 24px;
  font-weight: 300;
  padding: 0 0 10px 0;
  margin: 0 0 20px 0;
  border-bottom: 1px solid $teal;
}

.activity-feed-section {
  min-width: 100%;
  flex: 2;
}

</style>
